export enum FormMode {
  VIEW = 'VIEW',
  ADD = 'ADD',
  EDIT = 'EDIT',
}
